import { useEffect, useState } from 'react';
import { RequestHandler } from '../../../app/RequestHandler';
import { DisplayPopUpTypes, Filter } from '../../../interfaces';

interface FilterChildren {
  filters: Filter[];
}

export const useFilterChildren = (props: FilterChildren) => {
  const { filters } = props;
  const [filtersPopUp, setFiltersPopUp] = useState<Filter[]>([]);
  const [filtersChild, setFiltersChild] = useState<Filter[]>([]);
  const [externalUrl, setExternalUrl] = useState<string>('');
  const [popupType, setPopupType] = useState<DisplayPopUpTypes>();
  const { country, language } = new RequestHandler();

  useEffect(() => {
    if (filters && filters.length > 0) {
      const popUpsArray: Filter[] = [];
      const childrenArray: Filter[] = [];

      for (const child of filters) {
        const { url, type } = child.filterDisplayMode;
        if (url && url.length > 0) {
          setExternalUrl(`https://www.festo.com/${country}/${language}/x/mass-moment-of-inertia`);
        }
        type === 'CHILD' ? childrenArray.push(child) : popUpsArray.push(child);
        if (type === 'CHILD' || type === 'FILTER' || type === 'LINK_CALCULATION_MOMENT_OF_INERTIA') return;

        setPopupType(type);
      }

      setFiltersPopUp(popUpsArray ?? []);
      setFiltersChild(childrenArray ?? []);
    }
  }, [country, filters, language]);

  return {
    filtersPopUp,
    filtersChild,
    externalUrl,
    popupType,
  };
};
